var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.08 19.9299V27.5399C36.08 31.6399 32.75 34.9699 28.65 34.9699H8.96004C4.86004 34.9699 1.53003 31.6399 1.53003 27.5399V19.9299",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 29.6099V1.41992",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 23.01L18.8 29.61L12.21 23.01",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDownloadBlack);
export default __webpack_public_path__ + "static/media/app-download-black.a6744e00a73a432419750ad35e7ef56b.svg";
export { ForwardRef as ReactComponent };